module.exports = __webpack_public_path__ + "static/media/css.c7939545.png";